import _mixpanel from 'mixpanel-browser';
import { User } from '@/types/user';
import { Integration } from '../types';

export interface MixpanelConfig {
  token: string;
  debug?: boolean;
}

export const createMixpanelIntegration = (
  config: MixpanelConfig
): Integration => {
  _mixpanel.init(config.token, { debug: config.debug ?? false });

  let isIdentified = false;

  return Object.freeze({
    name: 'mixpanel',

    identify: (user: User): void => {
      _mixpanel.identify(user.user_id);

      _mixpanel.register({
        enterprise_id: user.enterprise_id,
      });

      _mixpanel.people.set({
        email: user.email,
        $first_name: user.first_name,
        $last_name: user.last_name,
        enterprise_id: user.enterprise_id,
      });

      isIdentified = true;
    },

    reset: (): void => {
      if (isIdentified) {
        _mixpanel.reset();
        isIdentified = false;
      }
    },

    track: (event: string, payload?: Record<string, any>): void => {
      _mixpanel.track(event, payload);
    },
  });
};
